import {businessList, list} from './list';

const subMenuCards = list.subMenuCards;
const subMenuCards2 = list.subMenuCards2;
const subMenuDeposits = list.subMenuDeposits;
const subMenuDeposits2 = list.subMenuDeposits2;
const subMenuCredit = list.subMenuCredit;
const subMenuCredit2 = list.subMenuCredit2;
const subMenuBusiness = list.subMenuBusiness;
const subMenuBusiness2 = list.subMenuBusiness2;
const subMenuBusiness3 = list.subMenuBusiness3;
const subMenuServices = list.subMenuServices;
const subMenuServices2 = list.subMenuServices2;
const subMenuServices3 = list.subMenuServices3;
const subMenuBusinessCalculations = businessList.subMenuBusinessCalculations;
const subMenuBusinessTrade = businessList.subMenuBusinessTrade;
const subMenuBusinessFreeMoney = businessList.subMenuBusinessFreeMoney;
const subMenuBusinessFinancing = businessList.subMenuBusinessFinancing;
const subMenuBusinessGov = businessList.subMenuBusinessGov;

import cardsCard1Desktop from './img/new/cards-card-1-desktop.png';
import cardsCard2Desktop from './img/new/cards-card-2-desktop.webp';
import cardsCard3Desktop from './img/new/cards-card-3-desktop.png';
import depositCardBackground from './img/new/deposit-card-mobile.webp';
import creditCardBackground from './img/new/credit-card-mobile.png';
import businessCardBackground from './img/new/business-card-mobile.png';
import businessImg from './img/new/business-img-mobile.svg';
import creditImgMobile from './img/new/credit-img-mobile.png';

export const getMenuConfig = () => [
    {
        alias: 'cards',
        smallBannersSubtitle: 'NEW_HEADER_CARDS_RECOMMENDED_PROPOSAL',
        smallBanners: [
            {
                href: '/cards/atb',
                img: cardsCard1Desktop,
                title: 'NEW_HEADER_CARDS_ATB_TITLE',
                text: 'NEW_HEADER_CARDS_ATB_SUBTITLE'
            },
            {
                href: '/cards/prostor',
                img: cardsCard2Desktop,
                title: 'NEW_HEADER_CARDS_PROSTOR_TITLE',
                text: 'NEW_HEADER_CARDS_PROSTOR_SUBTITLE'
            },
            {
                href: '/cards/vygoda',
                img: cardsCard3Desktop,
                title: 'NEW_HEADER_CARDS_VYGODA_TITLE',
                text: 'NEW_HEADER_CARDS_VYGODA_SUBTITLE'
            }
        ],
        columns: [
            {
                width: 220,
                subtitle: 'NEW_HEADER_CARDS_MAIN_CARDS',
                items: subMenuCards
            },
            {
                width: 320,
                subtitle: 'NEW_HEADER_CARDS_GOV_PROGRAMS',
                items: subMenuCards2
            }
        ]
    },
    {
        alias: 'deposits',
        columns: [
            {
                width: 220,
                subtitle: 'NEW_HEADER_DEPOSITS_DEPOSITS',
                items: subMenuDeposits
            },
            {
                width: 380,
                subtitle: 'NEW_HEADER_DEPOSITS_ADDITIONAL_SERVICES',
                items: subMenuDeposits2
            }
        ],
        banner: {
            href: '/deposits#frame',
            target: '_self',
            bg: depositCardBackground,
            title: 'NEW_HEADER_DEPOSITS_BANNER_TITLE',
            text: 'NEW_HEADER_DEPOSITS_BANNER_TEXT'
        }
    },
    {
        alias: 'credit',
        columns: [
            {
                width: 220,
                subtitle: 'NEW_HEADER_CREDIT_ALL',
                items: subMenuCredit
            },
            {
                width: 320,
                subtitle: 'NEW_HEADER_CREDIT_SPECIAL_OFFERS',
                items: subMenuCredit2
            }
        ],
        banner: {
            href: '/credit/pbp',
            target: '_self',
            bg: creditCardBackground,
            img: creditImgMobile,
            title: 'NEW_HEADER_CREDIT_BANNER_TITLE',
            text: 'NEW_HEADER_CREDIT_BANNER_TEXT'
        }
    },
    {
        alias: 'business',
        columns: [
            {
                width: 220,
                subtitle: 'NEW_HEADER_BUSINESS_CALCULATIONS',
                items: subMenuBusiness
            },
            {
                width: 220,
                subtitle: 'NEW_HEADER_BUSINESS_FINANCING',
                items: subMenuBusiness2
            },
            {
                width: 220,
                subtitle: 'NEW_HEADER_BUSINESS_ADDITIONAL',
                items: subMenuBusiness3
            }
        ],
        banner: {
            href: '/business/abusiness',
            target: '_self',
            bg: businessCardBackground,
            img: businessImg,
            title: 'NEW_HEADER_BUSINESS_BANNER_TITLE',
            text: 'NEW_HEADER_BUSINESS_BANNER_TEXT'
        }
    },
    {
        alias: 'services',
        columns: [
            {
                width: 272,
                subtitle: 'NEW_HEADER_SERVICES_CLIENT_SERVICES',
                items: subMenuServices
            },
            {
                width: 320,
                subtitle: 'NEW_HEADER_SERVICES_DOCUMENT_SERVICES',
                items: subMenuServices2
            },
            {
                width: 320,
                subtitle: 'NEW_HEADER_SERVICES_ADDITIONAL',
                items: subMenuServices3
            }
        ]
    },
    {
        alias: 'businessCalculations',
        columns: [{width: 220, items: subMenuBusinessCalculations}]
    },
    {
        alias: 'businessTrade',
        columns: [{width: 220, items: subMenuBusinessTrade}]
    },
    {
        alias: 'businessFreeMoney',
        columns: [{width: 220, items: subMenuBusinessFreeMoney}]
    },
    {
        alias: 'businessFinancing',
        columns: [{width: 332, items: subMenuBusinessFinancing}]
    },
    {
        alias: 'businessGov',
        columns: [{width: 406, items: subMenuBusinessGov}]
    }
];
